module.exports = __webpack_public_path__ + "files/1556bdccff37fc1c17f1105544e069b9.png";